import React, { FC } from 'react';
import './styles.scss';

interface IFormPanel {
  className?: string;
  children?: JSX.Element | JSX.Element[];
  header?: JSX.Element;
  title?: JSX.Element;
}

const FormPanel: FC<IFormPanel> = ({ className, children, header, title }) => (
  <section className={`invoice-form-panel ${className}`}>
    {header && <div className="invoice-form-panel-header">{header}</div>}
    <div className="invoice-form-panel-content">
      {title && (
        <div className="invoice-form-panel-title-wrap">
          <h3 className="invoice-form-panel-title">{title}</h3>
        </div>
      )}
      {children}
    </div>
  </section>
);

export default FormPanel;
